export default {
    converArrayCodeToCodeMap: (arrayCodeStr) => {
        let result = [];
        let codeArray = arrayCodeStr.split(',');

        for (let i = 0; i < codeArray.length; i++) {
            let curItem = codeArray[i];
            let [value, content] = curItem.split(':');
            value = String(value);
            content = String(content);

            result.push({
                value,
                content
            });
        }

        return result;
    },

    fiterCodeMapByPrefix: (codeMap, prefix) => {
        if (!codeMap) {
            throw new Error('CodeUtil.fiterCodeMapByPrefix:入参codeMap不能为空！');
        }

        if (!prefix) {
            return codeMap;
        }

        let prefixArray = prefix.split(',');
        let tempKey = null;

        let fiteredCodeMap = codeMap.filter((item) => {
            tempKey = item.value;

            for (let i = 0; i < prefixArray.length; i++) {
                if (tempKey.startsWith(prefixArray[i])) {
                    return true;
                }
            }
        });

        return fiteredCodeMap;
    },

    filterCodeMapByExcludeCodes: (codeMap, excludeCodes) => {
        if (!codeMap) {
            throw new Error('CodeUtil.fiterCodeMapByPrefix:入参codeMap不能为空！');
        }

        if (!excludeCodes) {
            return codeMap;
        }

        let excludeArray = excludeCodes.split(',');

        let fiteredCodeMap = codeMap.filter((item) => {
            for (let i = 0; i < excludeArray.length; i++) {
                if (item.value == excludeArray[i]) {
                    return false;
                }
            }

            return true;
        });

        return fiteredCodeMap;
    }
};
